<template>
  <section id="about__infantil" class="pb-4 fade-in-up">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <h2 class="text-title">Ensino Fundamental I</h2>
        </div>
      </div>
    </div>
    <BreadSistema class="bread__about" />

    <b-col class="contact-widget section-gap">
      <b-container>
        <b-row>

          <b-col sm="12" md="4" lg="4" xl="4" class="my-3 text-center">
            <b-col class="contact-us-item">
              <b-col class="contact-us--icon">
                <i class="fa fa-phone transform-icon"></i>
              </b-col>
              <b-col class="contact-us--content">
                <h4 class="font-weight-med mb-4">Fale Conosco - Telefones</h4>
                <p class="mb-1">
                  <a href="#">(11) 3740-2111</a>
                </p>
                <p class="mb-0">
                  <a href="#">(11) 3740-2115</a>
                </p>
              </b-col>
            </b-col>
          </b-col>

          <b-col sm="12" md="4" lg="4" xl="4" class=" my-3 text-center">
            <b-col class="contact-us-item">
              <b-col class="contact-us--icon">
                <i class="fa fa-envelope-o"></i>
              </b-col>
              <b-col class="contact-us--content">
                <h4 class="font-weight-med mb-4">Deixe-nos uma mensagem por E-mail</h4>
                <p class="mb-1">
                  <a href="mailto:atendimento@sistemacpv.com.br">atendimento@sistemacpv.com.br</a>
                </p>
                <!-- <p class="mb-0">
                    <a href="mailto:fernando.dacca@cpv.com.br">fernando.dacca@cpv.com.br</a>
                  </p>
                  <p class="mb-0">
                    <a href="mailto:elisangela.martins@cpv.com.br">elisangela.martins@cpv.com.br</a>
                  </p> -->

              </b-col>
            </b-col>
          </b-col>
          <b-col sm="12" md="4" lg="4" xl="4" class=" my-3 text-center">
            <b-col class="contact-us-item">
              <b-col class="contact-us--icon">
                <i class="fa fa-map-marker"></i>
              </b-col>
              <b-col class="contact-us--content">
                <h4 class="font-weight-med mb-4">Localização</h4>
                <p class="mb-1">
                  Rua Domingos Lopes da Silva, 34
                  <br />Cep: 05641-030 - Vila Suzano <br /> São Paulo - Sp
                </p>
              </b-col>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
    </b-col>

    <b-col class="contact-info  ">
      <b-col class="container">
        <b-col class="section-title-wrapper">
          <b-row>
            <b-col class="mx-auto text-center" sm="12" md="7">
              <h2>Via formulário</h2>
              <p class="mb-0 lead">Nosso time de atendimento irá retornar o mais breve possível dentro do horário
                comercial</p>
            </b-col>
          </b-row>
        </b-col>

        <b-row class="row align-items-center">
          <b-col sm="12" md="12" lg="7">
            <!-- Google Map -->
            <b-col class="google-maps">
              <b-col class="mapouter">
                <gmap-map :center="center" :zoom="17" style="width: '100%'; height: 435px" class="gmap_canvas">
                  <gmap-marker :position="markers.position" :clickable="true" :draggable="false"
                    @click="center = markers.position"></gmap-marker>
                </gmap-map>
              </b-col>
            </b-col>
          </b-col>
          <b-col class="col-sm-12 col-md-12 col-lg-5 contact-frm">
            <SendMessage></SendMessage>
          </b-col>
        </b-row>
      </b-col>
    </b-col>

  </section>
</template>

<script>
export default {
  metaInfo: { title: 'Fale Conosco' },
  components: {
    SendMessage: () => import("./OpenedSendFormContato.vue"),
    BreadSistema: () => import('../GlobalComponents/bread-sistema.vue')
  },

  data() {
    return {
      center: {
        lat: -23.617684,
        lng: -46.73632
      },
      markers: {
        position: {
          lat: -23.617684,
          lng: -46.73632
        }
      }
    };
  },
  mounted() {
    new WOW().init();
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.fade-in-up {
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

#about__infantil {
  margin-top: 0;

  background-color: #f6f6f6;
  color: #000000;

  p {
    font-size: 14px;
    line-height: 20px;
  }
}

#header {
  width: 100%;
  height: 500px;

  .img__header {
    position: absolute;
    display: block;
    background-image: url('https://sitecpv.s3.amazonaws.com/Images/sistema_contato-1920x1282.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 500px;
    object-fit: cover;
  }

  .bg__escuro {
    background: #00000074;
    background-size: 100% auto !important;
    width: 100%;
    height: 500px;
  }

  .bg__title {
    position: relative;
    width: 100%;
    min-height: 50px;
    max-height: 115px;
    padding: 35px 7%;
    top: -23%;
    bottom: 0%;

    display: flex;
    align-items: center;
    justify-content: end !important;

    background-color: #e98a2498;

    h2.text-title {
      color: #ffffff;

      font-size: 40px;
      font-weight: 600;

      line-height: 52px;

      text-shadow: 0 0 12px #00000024;
      text-align: end;

      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
}

.card-content {
  border-radius: 12px;

  h4 {
    font-size: 28px;
    line-height: 36px;
    color: #2d1a43;
  }

  h5 {
    font-size: 24px;
    line-height: 32px;
    color: #2d1a43;
  }

  p {
    font-size: 14px;
    line-height: 20px;
  }

  ul {
    list-style-type: none;
  }

  .list-proposta {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;

    .list-order {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #e98b24;
      border-radius: 50%;
      color: #fdf3e9;
    }
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 20px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 16px;
    line-height: 22px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 16px;
        line-height: 22px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

.decorator {
  border: 2px solid #f8dbbb;
  width: 60px;
  border-radius: 50px;
}

.unordered-list {
  .list {
    display: inline-flex;

    min-width: 100%;
    min-height: auto;

    padding: 10px 0 0;
    margin: auto;

    gap: 8px;

    .icon {
      width: 16px;
      height: 16px;

      padding-left: 0px;

      i {
        font-size: 14px;
        line-height: 20px;
        color: #d27d20;
      }
    }
  }
}

.subtitle__decorator {
  display: inline-flex;

  min-width: auto;
  min-height: auto;

  padding: 10px 8px;
  margin: auto;

  gap: 8px;

  span {
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
    color: #2d1a43;
  }

  .icon {
    width: 18px;
    height: 18px;

    padding-left: 4px;
    padding-right: 16px;

    i {
      font-size: 14px;
      line-height: 20px;
      color: #d27d20;

      border-bottom: 2px solid #d27d20;
      display: inline-flex;
      justify-content: center;
    }
  }
}
</style>
